import cx from 'classnames';

import './Section.scss';

export default function Section({ children, className }) {
  return <section className={cx(`eui-section`, className)}>{children}</section>;
}
